<div
    class="agpr-filterIncludeExclude"
>
    <agpr-radio
        [id]="'filterIncludeExclude_includeRadio'"
        [value]="includeExcludeEnum.include"
        label="Common.filter.include"
        [(ngModel)]="value"
        (onClick)="onModelChange(includeExcludeEnum.include)"
    ></agpr-radio>

    <agpr-radio
        [id]="'filterIncludeExclude_excludeRadio'"
        [value]="includeExcludeEnum.exclude"
        label="Common.filter.exclude"
        [(ngModel)]="value"
        (onClick)="onModelChange(includeExcludeEnum.exclude)"
    ></agpr-radio>
</div>

